// extracted by mini-css-extract-plugin
export default {"row":"footer_row__vJUlQ","footer":"footer_footer__w5sXF","footerWrapper":"footer_footerWrapper__DFJZJ","footerLogo":"footer_footerLogo__l6nDD"};